const Helpers =
{
    logstuff: () =>
    {
        console.log('FUNKAR');
    },
}

export default Helpers;
